import styled, { css, keyframes } from "styled-components";
import { mobileAuthSideContainer, mobileAuthMainContainer } from "../../../styles/authShellMixins";

export const MainContainer = styled.div`
  position: relative;
  display: flex;
  //flex-direction: column;
  //align-items: center;
  width: 100%;
  height: 100%;
  background: var(--app-bg-gradient);
  background-size: 400% 400%;
  font-family: "Inter", "Helvetica Neue", sans-serif;
  overflow-x: hidden;

  ${mobileAuthMainContainer}
`;

export const SideContainer = styled.div`
  scrollbar-width: none; 
  overflow-y: auto; 
  overflow-x: hidden; 
  position: relative; 
  height: 100vh; 
  min-height: 100vh; 
  width: ${({ collapsed }) => (collapsed ? "calc(100% - 6vw)" : "calc(100% - 15vw)")};
  margin: auto;
  transition: margin-left 0.5s ease-in-out, width 0.5s ease-in-out; 
  display: flex;
  flex-direction: column;
  align-items: center; /* Centraliza horizontalmente */
  justify-content: flex-start; /* Alinha no topo */

  &::-webkit-scrollbar {
    display: none; /* Remove scrollbar no Chrome/Safari */
  }

  ${mobileAuthSideContainer}
`;

// Wrapper do conteúdo
export const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: ${({ $embedded }) => ($embedded ? "900px" : "1200px")};
  padding: ${({ $embedded }) => ($embedded ? "0.25rem 0 1rem" : "2rem")};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding: ${({ $embedded }) =>
      $embedded ? "0.25rem 0 1rem" : "1rem 0.5rem 2rem"};
    max-width: 100%;
  }
`;

/** Root só no modo aba Guardian — garante centro mesmo com TabPanel stretch */
export const EmbeddedRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 2rem 0;
  text-shadow: 0 4px 20px color-mix(in srgb, var(--accent-secondary) 30%, transparent);
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const HeaderSection = styled.header`
  text-align: center;
  margin-bottom: 1rem;
  position: relative;
  width: 100%;
  max-width: 900px;
  align-self: center;
`;

export const FormContainer = styled.form`
  gap: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ $embedded }) => ($embedded ? "1.5rem" : "2.5rem")};
  border-radius: 20px;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 2px solid var(--border-subtle);
  width: ${({ $embedded }) => ($embedded ? "min(100%, 900px)" : "50vw")};
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  align-self: center;
  box-sizing: border-box;

  position: relative;
  overflow: hidden;
  min-height: 8vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, var(--accent-secondary-soft) 0%, var(--accent-soft) 100%);
    opacity: 0.3;
    z-index: -1;
    border-radius: 18px;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    max-width: 100%;
    padding: 1.5rem;
  }
`;

export const Row = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  width: 80%;
  position: relative; 
  z-index: 2;
  margin: auto;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 0.75rem;
    width: 100%;
    align-items: stretch;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
  min-width: 4vw;
  position: relative;
  z-index: 2;
  margin: auto;
`;

export const RightColumn = styled.div`
  flex: 2;
  min-width: 4vw;
  position: relative;
  z-index: 2;
  margin: auto;
`;

export const Label = styled.label`
  color: var(--text-heading);
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 0.5rem;
  display: block;
  position: relative;
  z-index: 2;
`;

export const ShowInput = styled.input`
  width: 27vw;
  min-width: 280px;
  height: 3vw;
  min-height: 44px;
  box-sizing: border-box;
  padding: 0.8vw 0.8vw;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  position: relative;
  z-index: 2;

  &::placeholder {
    color: var(--text-muted);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }
`;

export const StyledSelect = styled.select`
  width: 27vw;
  min-width: 280px;
  height: 3vw;
  min-height: 44px;
  box-sizing: border-box;
  padding: 0.8vw 0.8vw;
  padding-right: 50px; // Aumenta o espaço para a seta + margem
  border: 2px solid var(--border-default);
  border-radius: 12px;
  font-size: 14px;
  outline: none;
  background: var(--input-bg);
  color: var(--text-primary);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
  position: relative;
  z-index: 2;
  
  // Remove as propriedades de direção RTL
  text-align: left;
  direction: ltr;

  // Custom arrow (seta personalizada) na direita com margem
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23dbfb8e'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 20px center; // Seta na direita com margem
  background-size: 20px;

  option {
    background: var(--surface-overlay);
    color: var(--text-primary);
  }

  &:focus {
    border-color: var(--accent);
    background: var(--input-bg-focus);
    box-shadow: 0 0 0 3px var(--accent-soft);
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    min-width: 0;
    padding-right: 45px;
    background-position: right 15px center;
  }
`;

const solicitacaoGlow = keyframes`
  0%, 100% {
    box-shadow:
      0 0 0 2px color-mix(in srgb, var(--accent-secondary) 35%, transparent),
      0 0 14px color-mix(in srgb, var(--accent-secondary) 35%, transparent),
      0 0 28px var(--accent-soft);
    border-color: var(--text-heading);
  }
  50% {
    box-shadow:
      0 0 0 3px var(--border-strong),
      0 0 22px color-mix(in srgb, var(--accent-secondary) 55%, transparent),
      0 0 40px var(--accent-soft);
    border-color: var(--accent-secondary);
  }
`;

const solicitacaoNudge = keyframes`
  0%, 82%, 100% { transform: translateX(0); }
  86% { transform: translateX(-4px); }
  90% { transform: translateX(4px); }
  94% { transform: translateX(-3px); }
  98% { transform: translateX(2px); }
`;

const tipBounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
`;

export const SolicitacaoFieldWrap = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.45rem;
  width: fit-content;
  max-width: 100%;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const SolicitacaoSelect = styled(StyledSelect)`
  ${({ $highlight }) =>
    $highlight
      ? css`
          border-color: var(--text-heading);
          background: var(--table-row-hover);
          animation:
            ${solicitacaoGlow} 2.2s ease-in-out infinite,
            ${solicitacaoNudge} 4.5s ease-in-out infinite;

          &:focus {
            border-color: var(--accent-secondary);
            background: var(--accent-secondary-soft);
            box-shadow:
              0 0 0 3px var(--border-default),
              0 0 22px var(--accent-soft);
          }
        `
      : ""}
`;

export const SolicitacaoTip = styled.div`
  display: inline-flex;
  align-items: flex-start;
  gap: 0.4rem;
  max-width: 27vw;
  min-width: 280px;
  padding: 0.45rem 0.65rem;
  border-radius: 10px;
  border: 1px solid var(--border-default);
  background: var(--accent-soft);
  color: var(--text-heading);
  font-size: 11px;
  line-height: 1.35;
  animation: ${tipBounce} 1.8s ease-in-out infinite;

  strong {
    color: var(--accent-secondary);
  }

  @media screen and (max-width: 768px) {
    max-width: 100%;
    min-width: 0;
    width: 100%;
  }
`;

export const SolicitacaoTipPointer = styled.span`
  flex-shrink: 0;
  font-size: 13px;
  line-height: 1.2;
`;

export const FocusPriorityBox = styled.div`
  margin-top: 10px;
  padding: 0.55rem 0.75rem;
  border-radius: 10px;
  border: 1px solid #f59e0b;
  background: #fef3c7;
  color: #78350f;
  font-size: 12px;
  line-height: 1.4;

  strong {
    color: #92400e;
  }
`;

export const FocusListCaption = styled.div`
  margin-top: 8px;
  font-size: 11px;
  color: var(--text-heading);
`;

export const FocusList = styled.ol`
  margin: 6px 0 0;
  padding: 0;
  list-style: none;
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid var(--border-default);
  border-radius: 10px;
`;

export const FocusItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.45rem 0.65rem;
  font-size: 12px;
  line-height: 1.35;
  color: var(--text-heading);
  cursor: pointer;
  border-bottom: 1px solid var(--border-default);
  background: ${({ $priority, $selected }) =>
    $priority ? "#fef3c7" : $selected ? "var(--table-row-hover)" : "transparent"};
  ${({ $priority }) => ($priority ? "color: #78350f;" : "")}

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ $priority }) =>
      $priority ? "#fde68a" : "var(--table-row-hover)"};
  }
`;

export const FocusIndex = styled.span`
  flex-shrink: 0;
  min-width: 1.6rem;
  font-weight: 700;
`;

export const FocusMeta = styled.span`
  display: block;
  font-size: 11px;
  opacity: 0.8;
`;

export const FirmsLoadingBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-top: 10px;
  padding: 0.85rem 0.9rem;
  border-radius: 10px;
  border: 1px solid var(--accent);
  background: color-mix(in srgb, var(--accent) 12%, transparent);
  color: var(--text-heading);
  font-size: 13px;
  line-height: 1.4;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  position: relative;
  z-index: 2;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const StyledButton = styled.button`
  background: ${props => props.secondary 
    ? 'var(--input-bg)' 
    : 'var(--accent-secondary-soft)'};
  border: 2px solid ${props => props.secondary 
    ? 'var(--border-subtle)' 
    : 'var(--border-default)'};
  border-radius: 16px;
  color: ${props => props.secondary 
    ? 'var(--text-primary)' 
    : 'var(--text-heading)'};
  cursor: pointer;
  padding: 12px 24px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-width: 140px;
  min-height: 44px;
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, 
      ${props => props.secondary 
        ? 'var(--input-bg) 0%, var(--surface-glass) 100%' 
        : 'var(--accent-secondary-soft) 0%, var(--accent-soft) 100%'}
    );
    opacity: 0;
    transition: opacity 0.4s ease;
    border-radius: 14px;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 14px;
    background: transparent;
    box-shadow: ${props => props.secondary 
      ? 'var(--shadow-sm)' 
      : '0 6px 15px var(--accent-soft)'};
    opacity: 0;
    transition: opacity 0.4s ease;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-3px);
    border-color: ${props => props.secondary 
      ? 'var(--text-muted)' 
      : 'var(--accent)'};
    color: var(--text-primary);

    &::before {
      opacity: 1;
    }

    &::after {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    min-width: 120px;
    padding: 10px 20px;
  }
`;